import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    bottom: theme.spacing(5),
    display: 'flex',
    gap: theme.spacing(2),
    position: 'fixed',
    right: 'calc(50vw - 564px)',
    '& button': {
      width: 110,
    },
    '& #cancel-button': {
      color: theme.palette.primary1,
      background: '#F4F4F4',
    },
    [theme.breakpoints.down('xl')]: {
      right: 26,
    },
    [theme.breakpoints.down('md')]: {
      bottom: 12,
      right: 12,
      left: 12,
      '& button': {
        height: '44px',
        flexGrow: 1,
      },
    },
  },
}));
